export default __webpack_public_path__ + "static/media/notify_sensor.f1189193.svg";